import { Loading } from "@app/components";
import {
  useCalibrationUncertainty,
  useTypesUncertainty,
} from "@services/servicesGenericsTables";
import { useEffect, useRef } from "react";
import { Outlet } from "react-router-dom";

export default function LayoutUncertainty() {
  const fetched = useRef(false);

  const { fetchAll: fetchAllCalibration, loading } =
    useCalibrationUncertainty();
  const { fetchAll } = useTypesUncertainty();

  useEffect(() => {
    if (!fetched.current) {
      fetched.current = true;
      fetchAllCalibration();
      fetchAll();
    }
  }, []);

  return loading ? <Loading /> : <Outlet />;
}
